import { createContext, useContext } from 'react';

import { DateRange, DateValue } from '../types';

export type MonthPickerContextValue = {
	displayFormat?: 'short' | 'long';
	isClearable?: boolean;
	isDisabled?: boolean;
	value: DateRange;
	interimValue: DateRange;
	currentYear: number;
	onApply: () => void;
	onClear: () => void;
	onClose: () => void;
	onOpen: () => void;
	onPrevYear: () => void;
	onNextYear: () => void;
	onHoverMonth: (month: Date) => void;
	onSelectMonth: (month: DateValue) => void;
	onClearHover: () => void;
	selectionEnd: DateValue;
	selectionStart: DateValue;
	setRange: (range: DateRange) => void;
	disableMonthIf?: (month: Date, interimValue: DateRange) => boolean;
};

export const MonthPickerContext = createContext<MonthPickerContextValue | undefined>(undefined);

export const useMonthPickerContext = (): MonthPickerContextValue => {
	const context = useContext(MonthPickerContext);

	if (!context) {
		throw new Error('useMonthPickerContext must be used within a MonthPickerContext');
	}

	return context;
};
